import script from "./FreelanceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FreelanceCard.vue?vue&type=script&setup=true&lang=js"

import "./FreelanceCard.vue?vue&type=style&index=0&id=f24b6576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f24b6576"]])

export default __exports__